import WorkoutBanner from "../workoutBanner";
import WorkoutFeature from "../workoutFeature";
import WorkoutSetup from "../workoutSetup";
import SlidingText from "../../../components/SlidingText";
import TestimonialCarousel from "../../../components/TestimonialCarousel";
import InpersonLargeImage from "../../../assets/images/png/InPersonNewImg.png";

import Workout from "../../../assets/images/jpeg/inpersonWorkout.jpg";
import featureOne from "../../../assets/images/webp/programs/featureOne.webp";
import featureTwo from "../../../assets/images/webp/programs/featureTwo.webp";
import featureThree from "../../../assets/images/webp/programs/featureThree.webp";

import "../index.scss";
import CONSTANTS from "../../../utils/constants/CONSTANTS";

const InPerson = () => {
  const featureData = [
    {
      featureImg: featureOne,
      title: "Customize to your needs",
      description: "Work towards YOUR specific goals. No cookie cutter programs!",
    },
    {
      featureImg: featureTwo,
      title: "In-person coaching",
      description: "Hands-on with unmatched accountability!",
    },
    {
      featureImg: featureThree,
      title: "At your home, work, or outdoors",
      description: "Have access to a great workout wherever you are!",
    },
  ];
  return (
    <div className="inperson-workout">
      <WorkoutBanner
        mainHeading="In-Person"
        workoutImage={Workout}
        mainDescription="With over a decade of experience, Omni-Active® trainers know how to get you the results you want. After an initial consultation, we will match you with a trainer based on your goals, personality, and skill set. With this hands-on approach and higher level of accountability, reaching your goals is inevitable."
        description="Message your trainer directly, sign-in for sessions, and even receive workouts for the days you aren’t with us all within our industry changing app"
      />
      <div className="program-testimonials">
        <TestimonialCarousel images={CONSTANTS.inPersonTestimonials} />
      </div>
      <div className="workout-features">
        {featureData.map((feature, index) => (
          <WorkoutFeature
            featureImg={feature.featureImg}
            title={feature.title}
            description={feature.description}
            key={index}
          />
        ))}
      </div>
      <WorkoutSetup
        description="Bringing our customized, convenient, and creative workouts right to your doorstep, in-person training with Omni-Active® Fitness allows our clients to get a great workout alongside some of the industry's best trainers."
        pointOne="Sign up & subscribe for in-person workouts"
        pointTwo="Trainer sets up sessions at your preferred time"
        pointThree="The trainer visits you at your desired location to workout"
      />
      <div className="large-image">
        <img className="image" src={InpersonLargeImage} alt="" />
      </div>

      <SlidingText heading="We bring the" subHeading="workout to you" />
    </div>
  );
};
export default InPerson;
